// These same questions are rendered visibly and used in structured data.
import content from './search-content.json';
const asObjects = items => items.map(([question, answer]) => ({ question, answer }));
export const SERVICES_FAQ = asObjects(content.faqs['/services']);
export const TRAINING_FAQ = asObjects(content.faqs['/training']);
